export default "__VITE_ASSET__47201723__"